import { render, staticRenderFns } from "./DeliveryDetails.vue?vue&type=template&id=21ed651e&scoped=true"
import script from "./DeliveryDetails.vue?vue&type=script&lang=js"
export * from "./DeliveryDetails.vue?vue&type=script&lang=js"
import style0 from "./DeliveryDetails.vue?vue&type=style&index=0&id=21ed651e&prod&lang=scss&scoped=true"
import style1 from "./DeliveryDetails.vue?vue&type=style&index=1&id=21ed651e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ed651e",
  null
  
)

export default component.exports